__webpack_require__.p = "/banigame/banichance_s1404/";